<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: 0,
      }"
      show-footer
      :footer-span-method="footerColspanMethod"
      :footer-method="footerMethod"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { add, format } from '@/libs/util.number.js'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'defaultImageUrl',
          width: 90,
          title: this.$l('table_label_image') || '图片',
          headerAlign: 'left',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' },
        },
        {
          title: this.$l('form_label_skuNo') || '产品编号',
          field: 'skuNo',
          minWidth: 120,
          align: 'center',
        },
        {
          title: this.$l('form_label_goodsName') || '产品名称',
          field: 'goodsName',
          minWidth: 290,
          align: 'left',
        },
        {
          title: this.$l('form_label_quantity') || '数量',
          field: 'v_quantity',
          minWidth: 100,
          align: 'center',
        },
        {
          title: this.$l('form_label_goods_amount') || '金额',
          field: 'v_amount',
          minWidth: 120,
          align: 'center',
        },
      ],
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return []
      if (this.tableData.length <= 0) return []
      const quantitySum = this.tableData
        .map((item) => item.quantity)
        .reduce((r, n) => add(r, n), 0)
      const amountSum = this.tableData
        .map((item) => item.amount)
        .reduce((r, n) => add(r, n), 0)
      let footerRow = [
        this.$l('INDEX.total') || '合计',
        '',
        '',
        '',
        format(quantitySum),
        format(amountSum),
      ]
      return [footerRow]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
    footerColspanMethod({ _columnIndex }) {
      if (_columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 4,
        }
      } else if (_columnIndex == 1 || _columnIndex == 2|| _columnIndex == 3) {
        return {
          rowspan: 0,
          colspan: 0,
        }
      }
    },
  },
}
</script>
